import React from "react";
import { MARQUEE_WORDS } from "../lib/site";

export const Marquee = ({ dark = false }) => {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS, ...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div
      className={`relative overflow-hidden border-y ${dark ? "border-white/10 bg-brand-black" : "border-brand-line bg-brand-warm"}`}
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track py-5">
        {items.map((w, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6">
            <span
              className={`text-3xl font-extrabold uppercase tracking-tight sm:text-4xl ${
                i % 2 === 0
                  ? dark ? "text-white/90" : "text-brand-charcoal"
                  : "text-transparent [-webkit-text-stroke:1px_rgba(200,16,46,0.55)]"
              }`}
            >
              {w}
            </span>
            <span className="h-2 w-2 rotate-45 bg-brand-red" />
          </span>
        ))}
      </div>
    </div>
  );
};
